import React from "react";
import { TextField, Autocomplete } from "@mui/material";

type opt = {
  value: string;
  label: string;
};
interface Props {
  label?: string;
  optionsType?: opt[];
  getOptionDisabled?: any;
  error?: boolean;
  helperText?: any;
  selectedOption?: string;
  handleChange?: (v: string) => void;
  getOptionLabel: (option: any) => any;
  required?: boolean;
  name?: string;
  value?: any;
  loading?: boolean;
  disableClearable?: any;
  onChange?: (v: any) => void;
  disabled?: boolean;
  placeholder?: string;
}

export default function CommonAutoCompleteField({
  label = "Add Label",
  optionsType,
  error,
  handleChange,
  getOptionLabel,
  required = false,
  name = "",
  value = null,
  loading = false,
  disableClearable = false,
  helperText,
  onChange,
  disabled,
  getOptionDisabled,
  placeholder,
}: Props) {
  return (
    <Autocomplete
      id={name}
      size="small"
      fullWidth
      loading={loading}
      options={optionsType || []}
      disableClearable={disableClearable}
      value={value}
      onInputChange={(_e, v) => {
        handleChange && handleChange(v);
      }}
      disabled={disabled}
      onChange={(e, v) => onChange && onChange(v)}
      getOptionDisabled={getOptionDisabled}
      getOptionLabel={(option) => getOptionLabel(option)}
      renderInput={(params) => (
        <TextField
          {...params}
          required={required}
          error={error}
          helperText={helperText}
          id="outlined-basic"
          label={label}
          name={name}
          variant="outlined"
          size="small"
          placeholder={placeholder || ""}
          InputLabelProps={{
            shrink: true,
          }}
          fullWidth
        />
      )}
    />
  );
}
